import Header from './components/Header';
import HeroSection from './components/HeroSection';
import AboutSection from './components/AboutSection';
import RankingSection from './components/RankingSection';
import CarouselSection from './components/CarouselSection';
import CommentsSection from './components/CommentsSection';
import AppSection from './components/AppSection';
import TopicsSection from './components/TopicsSection';
import MediaSection from './components/MediaSection';
import FeaturesSection from './components/FeaturesSection';
import UpdatesSection from './components/UpdatesSection';
import IndexSection from './components/IndexSection';
import CardsSection from './components/CardsSection';
import FaqSection from './components/FaqSection';
import ContactSection from './components/ContactSection';
import Footer from './components/Footer';

export default function Home() {
  return (
    <div className="min-h-screen bg-background-50 text-foreground-200 font-sans">
      <Header />
      <main>
        <HeroSection />
        <AboutSection />
        <RankingSection />
        <CarouselSection />
        <CommentsSection />
        <AppSection />
        <TopicsSection />
        <MediaSection />
        <FeaturesSection />
        <UpdatesSection />
        <IndexSection />
        <CardsSection />
        <FaqSection />
        <ContactSection />
      </main>
      <Footer />
    </div>
  );
}